var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"ver-factura-modal","size":"xl","scrollable":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.facturaHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }